module.exports = __webpack_public_path__ + "static/img/qr-app.91270fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/qr-app.png
// module id = cX4e
// module chunks = 0